
interface WeChatType {
  oauth: () => string;
}
interface CryptoType {
  publickey: string;
}
interface CookieType {
  expires: string;
  name: string;
  path?: string;
}
interface MonitorType {
  autoView: boolean;
  url: string;
  user_name: string;
}
interface JssdkType { 
  url: string;
  jsApiList: string[];
}
export interface ConfigType {
  appid: string;
  storagePrefix?: string;
  wechat: WeChatType;
  crypto: CryptoType;
  monitor: MonitorType;
  jssdk: JssdkType;
}

const config: ConfigType = {
  appid: 'wx594855dad80a932f',// 公众号appid
  storagePrefix: '665d583c-',// node识别自动生成uuid
  wechat: {
    oauth: function () {
			const website_url = encodeURIComponent(window.location.href);
			// return `http://127.0.0.1:8088/api-dev/platform/wechat/auth/oauth?appid=wx594855dad80a932f&redirect_url=${website_url}`;
      return `https://loparex.mobi/api/platform/wechat/auth/oauth?appid=wx594855dad80a932f&redirect_url=${website_url}`;
		}
  },
  jssdk: {
    url: 'https://loparex.mobi/api/platform/jssdk',
    jsApiList: ["onMenuShareTimeline", "updateTimelineShareData", "onMenuShareAppMessage", "updateAppMessageShareData", "hideMenuItems"],
  },
  crypto: {
    publickey: `-----BEGIN PUBLIC KEY-----
    MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA7OlouSK7+4dgcEg7S7Bm
    ZcK/OclxEP+PxJs8eP96fCFMuzKez0200Ug4stTN6ip/IKEitxHOr7ye6jWv7fgk
    +3LPVvHwgLppsDUI2sagWYkNXHAqqTSKr8yCY5mMQHHXxXfdpVG95KkJD2ZGXjNS
    dj54lVq1u4DCf0cdl5Jgut02xMOBgdPYeb+4MD2n+bxuEAyuHX7o04w/kqSUSrd/
    F8vCchcwqS2S6dEgn/Gc73yV8dsnJOfS+Cem2u+N2epQSX0CEBoyBHbKFZQXRPLv
    2Zg54IBVNyHA8Lh7TWyuvqeaOlUO6OesFmpidG3kRveMCp7QOGfjz9BMq9OVOCuP
    2sFPH6CxlVPR/voovXqdC1ai9jCClO/A5xqaScjRRPsBo9v+thUE7E+b+4I0P0tK
    revocEGK2fVnoLHjfcB7wLZtAzBljggKAE0Yq9MLoejLJDPlCdl1Paah4beSVsZ9
    f5Pz/ya9MpD8AA34KdbdihlWhSGxC4031SjHLqBfOeTdWXNXxcuUd0+A3fFRY50A
    D5ls7+3/8gfUnFva4/bJLwY9FzxAr9ZGUJAvoP1/RVWBJa2aP8zes6Mb3mP00ppx
    wOuxB+y/Xx5PEG8aZD9nrvSuxz938Q0FXc89n9bb+oGlGo7T818gKA6JCwxCG+xw
    66m2pXBhuZl2a6sdmpoxXQkCAwEAAQ==
    -----END PUBLIC KEY-----`,
  },
  monitor: {// 这些信息全部向后台要
    autoView: true,// 是否开启页面自动监测
    url: '/api/platform/monitor',
    user_name: "",
  },
};

export default config;
